import "#vendor/intlTelInput/intlTelInput.js";

window.Sparkle ??= {};

window.Sparkle.Forms = jQuery.extend({ internationalPhoneInputSelector: ".phone-mask" }, window.Sparkle.Forms);

(function () {
  var assets = [
    window.SparkleConfig.assetPaths.intlTelInput,
    window.SparkleConfig.assetPaths.internationalPhoneInput,
    "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.1.6/js/utils.js",
  ];

  window.Sparkle.Forms.loadInternationalPhoneInput = function (inputs) {
    inputs = jQuery(inputs || window.Sparkle.Forms.internationalPhoneInputSelector);

    if (inputs.length) {
      // This library is big we want defer loading if needed, and avoid loading/parsing if not needed
      var promise = Sparkle.Codeload.importAll(assets);

      promise.then(function () {
        initPhoneInputs(inputs);
        initPhoneInputValidation();
      });

      return promise;
    } else {
      Sparkle.Codeload.prefetchAll(assets); // These may be needed on a different page so prefetch them if desired
    }

    function initPhoneInputs(inputs) {
      inputs.intlTelInput();
      inputs.closest("form").on("submit", function () {
        inputs.each(function () {
          jQuery(this).val(jQuery(this).intlTelInput("getNumber"));
        });
      });
    }

    function initPhoneInputValidation() {
      inputs.on("change", function (e) {
        if (!jQuery(this).intlTelInput("isValidNumber")) {
          e.target.setCustomValidity("Invalid Pattern");
        } else {
          e.target.setCustomValidity("");
        }
      });
    }
  };
})();
